import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Heart } from 'lucide-react'
import Header from '../components/Header'
import { useStore } from '../store/useStore'
import { useI18n } from '../i18n/useI18n'
import { storeTypeLabelKey, storeVisualKey } from '../lib/genre'

// お気に入り店一覧（#1078）。登録は StoreDetail の♡から。ここは閲覧＋店詳細への
// 導線。favorite は最小スナップショット（name/imageUrl/category）を持つので、
// 店マスタの読み込み状態に依存せず描画できる。タップ時は id 遷移し、StoreDetail
// 側が api.getStore(id) でフル情報を取り直す。

const categoryIcons: Record<string, string> = {
  restaurant: '🍽️', cafe: '☕', izakaya: '🏮', bar: '🍸', ramen: '🍜',
  sushi: '🍣', bakery: '🥐', sweets: '🍰', kitchencar: '🚐', shop: '🛍️',
  hotel: '🏨', other: '🏪',
}

export default function Favorites() {
  const navigate = useNavigate()
  const { t } = useI18n()
  const { favoriteStores, loadFavorites } = useStore()

  // マウント時に最新化（他端末での更新や、hydrate 前遷移に備える）。
  useEffect(() => {
    void loadFavorites()
  }, [loadFavorites])

  return (
    <div className="min-h-screen bg-warm-white">
      <Header title={t('favorites.title')} onBack={() => navigate(-1)} />

      {favoriteStores.length === 0 ? (
        <div className="flex flex-col items-center justify-center px-8 py-24 text-center">
          <Heart size={40} className="text-text-tertiary mb-3" />
          <p className="text-text-secondary font-body text-sm mb-1">{t('favorites.empty')}</p>
          <p className="text-text-tertiary font-body text-xs mb-6">{t('favorites.emptyHint')}</p>
          <button
            onClick={() => navigate('/stores')}
            className="rounded-full bg-yokoso-red text-white px-6 py-2.5 text-sm font-body font-medium tap-effect"
          >
            {t('favorites.browse')}
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-3 px-4 mt-3 pb-8">
          {favoriteStores.map((f) => (
            <button
              key={f.storeId}
              onClick={() => navigate(`/stores/${f.storeId}`)}
              className="flex flex-row bg-white rounded-xl shadow-card p-3 text-left tap-card animate-fade-in"
            >
              {f.imageUrl ? (
                <img src={f.imageUrl} className="w-20 h-20 rounded-xl object-cover shrink-0" />
              ) : (
                <div className="w-20 h-20 rounded-xl bg-gray-100 flex items-center justify-center text-3xl shrink-0">
                  {categoryIcons[storeVisualKey(f)] || '🏪'}
                </div>
              )}
              <div className="flex flex-col justify-center ml-3 min-w-0 flex-1">
                <h3 className="font-display font-semibold text-lg text-text-primary leading-tight truncate">
                  {f.name}
                </h3>
                {f.nameEn && (
                  <p className="text-xs font-body text-text-secondary truncate mt-0.5">
                    {f.nameEn}
                  </p>
                )}
                <div className="flex items-center gap-1 mt-1">
                  <span className="text-sm">{categoryIcons[storeVisualKey(f)] || '🏪'}</span>
                  <span className="text-sm font-body text-text-secondary">
                    {t(storeTypeLabelKey(f))}
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
